// extracted by mini-css-extract-plugin
export var bounce = "component-module--bounce--6e557";
export var fadeIn = "component-module--fadeIn--af7ef";
export var navigationHeader = "component-module--navigationHeader--a0eb1";